// extracted by mini-css-extract-plugin
export default {"mobileMenu":"mobileMenu___xxpv6","mobileMenu_section":"mobileMenu_section___XpoFq"};